import React from 'react'
import loading from 'components/listings/listing/summary/row3/photos/images/loading.gif'

const images = (ml, pics, lazy) => {
  const count = pics.length

  // url is HH URL or GLAR pic ID
  return pics.map((url, i) => {
    let src = loading
    if (!lazy || i < 2) {
      src = url
    }

    // full domain for dev's benefit
    const load = src.includes(loading)
    if (!load) {
      src = `https://HardinHomes.com/listing-pics/${ml}/${src}`
    }

    // sometimes 0 / 0 displays and scroll is messed up
    const delay = count === 1 || i !== 0 ? 'eager' : 'lazy'
    return (
      <img
        key={url}
        alt={`${i + 1} of ${count} for MLS listing ${ml}`}
        src={src}
        loading={delay}
      />
    )
  })
}

export default images
